export default defineNuxtPlugin(async () => {
    const router = useRouter()
    const getCook = useCookie('_xloginsession')
    if (getCook.value) {
        const { data } = await RFetch('/system/auth/me')
        if (data) useState('auth', () => data)
        if (!data?.id) router.push('/login')
    }
})
